import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../redux/store';
import i18n from '../localization/i18n';
import en from '../localization/translations/translations_en.json';
import de from '../localization/translations/translations_de.json';
const baseTitle = 'CDE Infrastructure | Thinkproject';

i18n.addResourceBundle('en', 'browserTitle', en.browserTitle);
i18n.addResourceBundle('de', 'browserTitle', de.browserTitle);

export const useDynamicBrowserTitle = () => {
    const { t } = useTranslation('browserTitle');
    const route = useLocation();

    const projects = useSelector((store: IAppReduxStore) => store.userProjects.data);
    const documentData = useSelector((store: IAppReduxStore) => store.projectDocumentDetails.data);

    const [browserTitle, setBrowserTitle] = useState<string>(baseTitle);

    useEffect(() => {
        onLocationChange();
    }, [route, projects, documentData]);

    const onLocationChange = () => {
        const [subroute, replicaId, documentId] = route.pathname.substring(1).split('/');
        let preTitle = '';

        if (subroute === '') {
            preTitle = t('projects') + ': ';
        }

        if (subroute === 'project' && replicaId) {
            const project = projects.find(project => project.replicaId === replicaId);

            if (project?.module?.translations) {
                const moduleLabel = project.module.translations[i18n.language];
                moduleLabel && (preTitle = moduleLabel + ': ');
            }
        }

        if (subroute === 'document' && documentId && documentData?.docNumber) {
            preTitle = documentData?.docNumber + ': ';
        }

        setBrowserTitle(preTitle + baseTitle);
    };

    return browserTitle;
};
